module.exports = __webpack_public_path__ + "media/images/sales/early/btn-cta-8-79432d063a794f6d6715694a5cef7862.svg";